// Centralized data-testid registry. Keep these stable for the test agent.

export const HEADER = {
  root: "site-header",
  logo: "header-logo",
  navHome: "nav-home",
  navCourses: "nav-courses",
  navCorporate: "nav-corporate",
  navLeadership: "nav-leadership",
  navResources: "nav-resources",
  navContact: "nav-contact",
  navCoursesTrigger: "nav-courses-trigger",
  navVideoCourse: "nav-video-course",
  navVideoCourseTrigger: "nav-video-course-trigger",
  ctaEnquire: "header-cta-enquire",
  ctaExplore: "header-cta-explore",
  mobileToggle: "mobile-menu-toggle",
  mobileMenu: "mobile-menu",
};

export const HERO = {
  root: "hero-section",
  headline: "hero-headline",
  primaryCta: "hero-primary-cta",
  secondaryCta: "hero-secondary-cta",
  trustBadges: "hero-trust-badges",
};

export const LEAD_FORM = {
  root: "lead-form",
  name: "lead-form-name",
  email: "lead-form-email",
  phone: "lead-form-phone",
  course: "lead-form-course",
  courseOther: "lead-form-course-other",
  category: "lead-form-category",
  trainingType: "lead-form-training-type",
  company: "lead-form-company",
  college: "lead-form-college",
  teamSize: "lead-form-team-size",
  timeline: "lead-form-timeline",
  message: "lead-form-message",
  submit: "lead-form-submit",
  success: "lead-form-success",
};

export const CATEGORY_EXPLORER = {
  root: "category-explorer",
  tab: (id) => `category-tab-${id}`,
  panel: "category-panel",
  cta: "category-panel-cta",
};

export const COURSE_PATHWAYS = {
  root: "course-pathways",
  search: "course-pathways-search",
  tag: (t) => `course-tag-${t.toLowerCase().replace(/\s+/g, "-")}`,
  card: (slug) => `course-card-${slug}`,
  viewDetails: (slug) => `course-card-view-${slug}`,
};

export const COURSE_MODAL = {
  root: "course-detail-modal",
  close: "course-detail-modal-close",
  enquire: "course-detail-modal-enquire",
};

export const FAQ = {
  root: "faq-section",
  item: (i) => `faq-item-${i}`,
};

export const FOOTER = {
  root: "site-footer",
  cta: "footer-cta",
};

export const STICKY_CTA = "sticky-enquire-cta";

// Booking modal opened directly after the lead forms that opted into it
// succeed (see BookCallFlow.jsx). Already set to the right persona from
// which form the visitor submitted -- no separate prompt step, no
// in-modal persona toggle.
export const BOOKING_MODAL = {
  root: "booking-modal",
  skip: "booking-modal-skip",
  name: "booking-modal-name",
  email: "booking-modal-email",
  phone: "booking-modal-phone",
  courseCategory: "booking-modal-course-category",
  courseName: "booking-modal-course-name",
  timeline: "booking-modal-timeline",
  companyName: "booking-modal-company-name",
  workEmail: "booking-modal-work-email",
  teamSize: "booking-modal-team-size",
  preferredTimeline: "booking-modal-preferred-timeline",
  notes: "booking-modal-notes",
  date: "booking-modal-date",
  time: "booking-modal-time",
  submit: "booking-modal-submit",
  success: "booking-modal-success",
};

export const PAGES = {
  home: "page-home",
  about: "page-about",
  courses: "page-courses",
  corporate: "page-corporate",
  leadership: "page-leadership",
  contact: "page-contact",
  courseDetail: "page-course-detail",
  payment: "page-payment",
  talkToAdvisor: "page-talk-to-training-advisor",
};

// Standalone one-page booking form at /talk-to-training-advisor -- unlike
// BOOKING_MODAL above (which only ever opens already set to a fixed
// persona from a prior lead form), this one lets the visitor pick their
// own persona and fill in every booking field manually, with no separate
// lead-capture step first.
export const ADVISOR_BOOKING_FORM = {
  root: "advisor-booking-form",
  name: "advisor-booking-name",
  email: "advisor-booking-email",
  phone: "advisor-booking-phone",
  personaIndividual: "advisor-booking-persona-individual",
  personaCorporate: "advisor-booking-persona-corporate",
  courseCategory: "advisor-booking-course-category",
  courseName: "advisor-booking-course-name",
  courseNameManualToggle: "advisor-booking-course-name-manual-toggle",
  courseMode: "advisor-booking-course-mode",
  timeline: "advisor-booking-timeline",
  date: "advisor-booking-date",
  time: "advisor-booking-time",
  companyName: "advisor-booking-company-name",
  teamSize: "advisor-booking-team-size",
  notes: "advisor-booking-notes",
  submit: "advisor-booking-submit",
  success: "advisor-booking-success",
};
